export const cleanGtins = (gtin: string) => {
    return gtin.trim().padStart(14, '0');
};
